import { Grid } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type Employee from 'modules/employees/store/models/Employee'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import ForfaitJours from '../France/ForfaitJours'
import JoursParAn from '../France/JoursParAn'

interface Props {
  contractVersion: ContractVersion
  employee: Employee
}

const Italy = ({ contractVersion, employee }: Props) => {
  const canEdit = policyAuthorizations.for('contracts.edit', employee)
  const hasForfaitJours = !!contractVersion.attributes.fr_forfait_jours
  const joursParAn = hasForfaitJours ? contractVersion.attributes.fr_jours_par_an_cents : null
  const showJoursParAn = (hasForfaitJours && !!joursParAn) || canEdit

  return (
    <Grid variant="fixed">
      <ForfaitJours hasForfaitJours={hasForfaitJours} />
      {showJoursParAn && <JoursParAn joursInCents={joursParAn ?? undefined} />}
    </Grid>
  )
}

export default observer(Italy)
